import { useState, useEffect, useCallback } from 'react';
import {
  getCurrentTheme,
  setTheme,
  toggleDarkMode,
  onThemeChange,
  getAvailableThemes,
  initializeTheme,
  type Theme,
} from '@/styles/theme.util';

/**
 * Custom hook for theme management
 */
export function useTheme() {
  const [theme, setThemeState] = useState<Theme | null>(null);

  useEffect(() => {
    // Initialize theme on mount
    initializeTheme();
    setThemeState(getCurrentTheme());

    // Listen for theme changes
    const unsubscribe = onThemeChange((newTheme) => {
      setThemeState(newTheme);
    });

    return unsubscribe;
  }, []);

  const changeTheme = useCallback((newTheme: Theme) => {
    setTheme(newTheme);
    setThemeState(newTheme);
  }, []);

  const toggleTheme = useCallback(() => {
    const newTheme = toggleDarkMode();
    setThemeState(newTheme);
  }, []);

  return {
    theme,
    setTheme: changeTheme,
    toggleTheme,
    isLoading: theme === null,
    availableThemes: getAvailableThemes(),
  };
}
